import React, { Component } from "react";
import CoverPage from "views/Pma/PmaEditor/FirstPageComponents/CoverPage";

class YETwoFirstRight extends Component {
  render() {
    const {
      agentData,
      coverPageDetails,
      currentArea,
      hoData,
      aprilData,
      printVersion,
      fromEditor,
      demoAccountCoverPhoto,
      demoAccountAreaName,
      quarterlyAreaTable,
      version,
      isDemo,
      quadrantModalOpen,
      showAllEditButtons,
    } = this.props;

    return (
      <div className="ye2-first-right">
        <CoverPage
          agentData={agentData}
          currentArea={currentArea}
          coverPageDetails={coverPageDetails}
          hoData={hoData}
          printVersion={printVersion}
          fromEditor={fromEditor}
          demoAccountCoverPhoto={demoAccountCoverPhoto}
          demoAccountAreaName={demoAccountAreaName}
          quarterlyAreaTable={quarterlyAreaTable}
          currentSoldListings={quarterlyAreaTable.currentSoldListings}
          marketHighLightsData={quarterlyAreaTable.marketHighLightsData}
          photoNum="1"
          version={version}
          only6Months={true}
          typeOfVersion="ye2"
          aprilData={aprilData}
          yearEnd={true}
          //printDate="January 20"
          isDemo={isDemo}
          quadrantModalOpen={quadrantModalOpen}
          showAllEditButtons={showAllEditButtons}
        />
      </div>
    );
  }
}

export default YETwoFirstRight;
